import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ContentDiv } from "./pages/ContentStyles";
import Menu     from "./pages/Menu";
import Footer   from './pages/Footer';
import NoPage                 from "./pages/common/NoPage";
import Contact                from "./pages/common/Contact";
import Login                  from "./pages/common/Login";
import Cities                  from "./pages/Cities";
import PasswordChange                  from "./pages/common/PasswordChange";
import Test from "./pages/Test";
import MyPage                 from "./pages/common/MyPage"

import Home     from "./pages/Home";

import CookieConsent   from "./pages/CookieConcent"

export default function App() {
  return (
    <>      
        <BrowserRouter>
        <ContentDiv>
          <Routes>
            <Route index                                  element={<Home />} />
            <Route path="login"                           element={<Login />} />
            <Route path="mypage"                          element={<MyPage />} />
            <Route path="cities"                          element={<Cities />} />
            <Route path="test"                            element={<Test />} />
            <Route path="contact"                         element={<Contact />} /> 
            <Route path="password/change"                 element={<PasswordChange />} /> 
            <Route path="*"                               element={<NoPage />} />
          </Routes>
          </ContentDiv>
        </BrowserRouter>

      <Footer />
      <CookieConsent />
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("main") );
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const top = ReactDOM.createRoot(document.getElementById("top") );
top.render(
  <React.StrictMode>
    <Menu />
  </React.StrictMode>
);
